import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// export const get_upcoming_appoitnments = async (flag, is_people) => {
//     const response = await axios.post(
//         secureLocalStorage.getItem("baseURL") + '/api/get-upcoming-and-past-appointments',
//         { flag }
//     );
//     return response.data;
// }
export const get_upcoming_appoitnments = async (flag, is_people) => {
  const endpoint = is_people
    ? '/api/get-people-upcoming-and-past-appointments'
    : '/api/get-upcoming-and-past-appointments'

  const response = await axios.post(
    secureLocalStorage.getItem('baseURL') + endpoint,
    { flag }
  )

  return response.data
}
export const get_latest_appoitnments = async () =>{
    const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/get-recent-payments')
    return response.data;
}
export const get_appoitnments_by_locations = async (locationId) =>{
    const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/appointments-by-location/' + locationId)
    return response.data;
}
export const get_auth_user  = async () =>{
    const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/auth-user')
    return response.data;
}